import WPAPI from 'wpapi';
import fetch from 'node-fetch';
import config from '../../config';

const wp = new WPAPI({ endpoint: config.apiUrl });

const customTypes = [
  'news',
  'insight',
  'education',
  'press_release',
  'technical',
  'podcast',
  'whats_brewing'
];
const allCustomTypeAPIFilter = customTypes.reduce(
  (tot: string, curr: string) => `${tot}type[]=${curr}&`,
  ''
);

// This route is copied from the plugin: wordpress/wp-content/plugins/wp-rest-api-v2-menus/wp-rest-api-v2-menus.php
wp.menus = wp.registerRoute('menus/v1', '/menus/(?P<id>[a-zA-Z(-]+)');

wp.news = wp.registerRoute('wp/v2', '/news/(?P<slug>[a-zA-Z(-]+)');
wp.insights = wp.registerRoute('wp/v2', '/insight/(?P<slug>[a-zA-Z(-]+)');
wp.technicals = wp.registerRoute('wp/v2', '/technical/(?P<slug>[a-zA-Z(-]+)');
wp.events = wp.registerRoute('wp/v2', '/event/(?P<slug>[a-zA-Z(-]+)');
wp.prs = wp.registerRoute('wp/v2', '/press_release/(?P<slug>[a-zA-Z(-]+)');
wp.podcasts = wp.registerRoute('wp/v2', '/podcast/(?P<slug>[a-zA-Z(-]+)');
wp.whatsBrewing = wp.registerRoute(
  'wp/v2',
  '/whats_brewing/(?P<slug>[a-zA-Z(-]+)'
);

export const fetchEvent = async (slug: string) => {
  const page = await wp
    .events()
    .slug(slug)
    .embed()
    .then((data: any) => {
      return data[0];
    });

  return page;
};

export const fetchUpcomingEvents = async (perPage = 5) => {
  return fetch(
    `${config.apiUrl}/abn/v1/upcoming_events?per_page=${perPage}`
  ).then(res => res.json());
};

export const fetchUpcomingConferenceEvent = async () => {
  return fetch(`${config.apiUrl}/abn/v1/upcoming_conference`).then(res =>
    res.json()
  );
};

export const fetchUpcomingCompetitionEvent = async () => {
  return fetch(`${config.apiUrl}/abn/v1/upcoming_competition`).then(res =>
    res.json()
  );
};

export const fetchUpcomingTechnicalEvents = async () => {
  return fetch(
    `${config.apiUrl}/abn/v1/upcoming_technical_sessions`
  ).then(res => res.json());
};

export const fetchDraftClassifiedById = async (id: string) => {
  return fetch(`${config.uiUrl}/classified/preview/${id}`).then(res =>
    res.json()
  );
};

export const fetchMenus = async () => {
  const header = await wp.menus().id('header-menu');
  const footer = await wp.menus().id('footer-menu');

  return [header, footer];
};

export const fetchTopicPosts = async (slug: string, page = 1) => {
  const categories = await wp.categories().slug(slug);
  const categoryId = categories.length ? categories[0].id : null;

  const posts = await fetch(
    `${config.apiUrl}/wp/v2/posts?${allCustomTypeAPIFilter}categories=${categoryId}&page=${page}`
  ).then(res => res.json());

  return {
    category: categories[0],
    categoryId: categories[0].id,
    posts
  };
};

export const fetchTagPosts = async (slug: string, page = 1) => {
  const tags = await wp.tags().slug(slug);
  const tagId = tags.length ? tags[0].id : null;

  const posts = await fetch(
    `${config.apiUrl}/wp/v2/posts?${allCustomTypeAPIFilter}tags=${tagId}&page=${page}`
  ).then(res => res.json());

  return {
    tag: tags[0],
    posts
  };
};

export const fetchPosts = async (type: string, page = 1) => {
  const res = await fetch(
    `${config.apiUrl}/wp/v2/posts?type[]=${type}&page=${page}`
  );
  const posts = await res.json();
  const total = res.headers.get('X-WP-Total') || 0;
  return {
    total,
    posts
  };
};

export const fetchResources = async (page = 1) => {
  const res = await fetch(
    `${config.apiUrl}/wp/v2/posts?type[]=education&type[]=press_release&type[]=technical&type[]=podcast&page=${page}`
  );
  const posts = await res.json();
  const total = res.headers.get('X-WP-Total') || 0;
  return {
    total,
    posts
  };
};

export const fetchPage = async (slug: string) => {
  const page = await wp
    .pages()
    .slug(slug)
    .embed()
    .then(data => {
      return data[0];
    });
  return page;
};

export const fetchPost = async (slug: string) => {
  const post = await fetch(
    `${config.apiUrl}/wp/v2/posts?${allCustomTypeAPIFilter}slug=${slug}&_embed`
  ).then(res => res.json());
  return post[0];
};

export const fetchCategoryById = async (id: number) => {
  const category = await wp.categories().id(id);
  return category;
};

export const fetchCurrentUser = async () => {
  const token = localStorage.getItem(config.AUTH_TOKEN);
  if (token) {
    wp.setHeaders({ Authorization: `Bearer ${token}` });
    wp.users().me();
  }
};
